import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_FAILURE,
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressIsLoadingState = boolean;

const initialState: ContractProgressIsLoadingState = false;

export default function reducer(
  state: ContractProgressIsLoadingState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return true;
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS:
    case CONTRACT_PROGRESS_CONTRACT_LOAD_FAILURE:
      return false;
    default:
      return state;
  }
}
